import commonMenu from './commonMenu.js';
export default {
    path: '/',
    redirect: 'home',
    component: () => import('@/views/homePage/index.vue'),
    meta: {},
    children: [
		{
			path:'/article_details',
			name:'article_details',
			component:() => import('@/views/article_details/index.vue')
		},
        {
            path: '/home',
            component: () => import('@/views/homePage/index/index.vue'),
        },
        {
            path: '/chongzhi',
            component: () => import('@/views/common/page/chongzhi'),
        },
        {
            path: '/apply',
            component: () => import('@/views/common/page/apply'),
        },
        ...commonMenu,
    ]
}